// @ts-nocheck
export enum ModalTypes {
  CreateTaskModal = 'CreateTaskModal',
}
